module.exports = __webpack_public_path__ + "img/title-2.71ec72e4.png";